import { fetchJson } from '@pkgs/api/utils/fetch';
import { type InputContact } from '@pkgs/api';

import { type ResultOrError } from '@/types/fetch.types';

export const sendContactFormService = async (
  propertyId: string,
  contactFormData: InputContact,
  captchaSolution: string,
): Promise<ResultOrError<unknown>> => {
  const url = `${process.env.NEXT_PUBLIC_VERCEL_DOMAIN ?? ''}/api/contact/lead`;

  try {
    const data = await fetchJson<unknown>(url, {
      body: JSON.stringify({
        ...contactFormData,
        propertyId,
        captchaSolution,
      }),
      headers: {
        'Content-Type': 'application/json',
        ...(process.env.NEXT_PUBLIC_VERCEL_PROTECTION_BYPASS_TOKEN && {
          'x-vercel-protection-bypass': process.env.NEXT_PUBLIC_VERCEL_PROTECTION_BYPASS_TOKEN,
        }),
      },
      method: 'POST',
    });
    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error',
    };
  }
};
